import React from "react";
import NumberFormat from "react-number-format";

const ThousandFormatter = ({onChange, inputRef, ...props}) => {
    return (
        <NumberFormat
            {...props}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value
                    }
                });
            }}
            thousandSeparator
        />
    );
}

export default ThousandFormatter;